import { BaseRouteService } from 'core/services';

class LookupRouteService extends BaseRouteService {
    constructor() {
        super('lookups');
    }

    getLookups(embed) {
        return super.get(`${this.base}/data?embed=${embed}`);
    }

    syncNikoPriceGroups() {
        return super.get(`${this.base}/sync-niko-pricing-groups`);
    }
}

export default LookupRouteService;
